import { render, staticRenderFns } from "./pointDown.vue?vue&type=template&id=0250b428&scoped=true&"
import script from "./pointDown.vue?vue&type=script&lang=js&"
export * from "./pointDown.vue?vue&type=script&lang=js&"
import style0 from "./pointDown.vue?vue&type=style&index=0&id=0250b428&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0250b428",
  null
  
)

export default component.exports